import angular from 'angular';
import uiRouter from 'angular-ui-router';
import codingactivityComponent from './codingactivity.component';

let codingactivityModule = angular.module('codingactivity', [
  uiRouter
])

.component('codingactivity', codingactivityComponent);

export default codingactivityModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/codingactivity/codingactivity.js